export const ROOM_MESSAGE = "m.room.message";
export const ROOM_ENCRYPTED = "m.room.encrypted";
export const ROOM_MEMBER = "m.room.member";
export const CALL_INVITE = "m.call.invite";
export const CALL_ANSWER = "m.call.answer";
export const CALL_CANDIDATES = "m.call.candidates";
export const CALL_HANGUP = "m.call.hangup";
export const CALL_REJECT = "m.call.reject";
export const CALL_NOTE = "com.memotivationapp.call.note";
export const MEETING_PARTICIPANT_NOTIFICATION = "com.memotivationapp.meeting.participant";
export const MATRIX_RTC_CALL_NOTIFY = "org.matrix.msc4075.call.notify";
export const MATRIX_RTC_NOTIFICATION = "org.matrix.msc4075.rtc.notification";
export const MATRIX_RTC_MEMBER = "org.matrix.msc3401.call.member";
export const BAD_ENCRYPTED = "m.bad.encrypted";

export const LOCAL_ECHO = "isLocalEcho";
export const EVENT_ID_TO_REPLACE = "eventIdToReplace";

export const DECRYPTION_FAILURE_MESSAGE = "(Encrypted Message)";
